<template>
  <containElement>
  </containElement>
</template>

<script>
import containElement from '@/components/Container.vue'
import { getObjFromUrl, getBaseErrorObj } from '@/utils'
import { clientError } from '@/api/public'
import { getNameById } from '@/api/baseInfo'
import { getBrands } from '@/api/search'
import { listenPerformance } from '@/api/performance'
import ErrorStackParser from 'error-stack-parser'
export default {
  components: { containElement },
  /*computed: {
    searchParam() {
      return getObjFromUrl(window.location.href)
    },
  },*/
  data() {
    return {
      listenInterValId: null,
    }
  },
  methods: {
    //根据ID获取名称，适用于将地址直接输入到浏览器（尤其是未经过页面选择方式设置参数而是直接读取浏览器地址栏参数的跨域浏览器）中回车时，解决相关名称回显问题
    getDefaultNameData() {
      let brand_id = this.$store.state.user.selectedType
        ? this.$store.state.user.selectedType.join(',')
        : ''
      let param = { brand_id: brand_id, kol_id: this.$store.state.user.KolId }
      getNameById(param)
        .then((res) => {
          if (res.status == 'ok') {
            let data = res.result.data
            if (data.kol && data.kol.length > 0) {
              this.$store.dispatch('user/changeKolName', data.kol[0].kol_name)
              localStorage.setItem('kol_name', data.kol[0].kol_name)
            } else if (data.brand && data.brand.length > 0) {
              this.$store.dispatch('user/changeBrandName', data.brand)
              localStorage.setItem('brandName', JSON.stringify(data.brand))
            }
          }
        })
        .catch((e) => {})
    },
    //查询默认的十个品牌
    getDefaultBrandOptions() {
      let param = { brand_name: '' }
      getBrands(param).then((res) => {
        if (res.status == 'ok') {
          localStorage.setItem(
            'defaultBrandOption',
            JSON.stringify(res.result.data)
          )
        }
      })
    },
    chageFavicon() {
      if (this.$store.state.user.loginInfo.is_partner) {
        if (this.$store.state.user.loginInfo.partner_title) {
          document.title = this.$store.state.user.loginInfo.partner_title
        }
        let favicon = document.querySelector("link[rel~='icon']")
        if (this.$store.state.user.loginInfo.partner_ico_url) {
          favicon.href = this.$store.state.user.loginInfo.partner_ico_url
        } else {
          favicon.href = './not.png'
        }
      }
    },
    setupPerformanceObserver() {
      // 创建PerformanceObserver实例
      const supportedTypes = PerformanceObserver.supportedEntryTypes
      const observer = new PerformanceObserver((list) => {
        const entries = list.getEntries()
        entries.forEach((entry) => {
          //   console.log(`[性能指标] ${entry.name}:`, entry);
          //   if (entry.entryType === 'navigation') {
          //     console.log(`[性能指标] ${entry.name}:`, entry)
          //     console.log('页面导航耗时:', {
          //       DNS查询: entry.domainLookupEnd - entry.domainLookupStart,
          //       TCP连接: entry.connectEnd - entry.connectStart,
          //       请求响应: entry.responseEnd - entry.requestStart,
          //       DOM解析: entry.domComplete - entry.domInteractive,
          //       页面加载总时间: entry.loadEventEnd - entry.startTime,
          //       重定向耗时: entry.redirectEnd - entry.redirectStart,
          //       DOM加载时间: entry.domComplete - entry.domContentLoadedEventStart,
          //     })
          //   }
          // LCP (最大内容绘制)
          //   if (entry.entryType === 'largest-contentful-paint') {
          //     console.log('LCP:', entry.renderTime || entry.loadTime, 'ms')
          //   }
          //   // FID (首次输入延迟)
          //   if (entry.entryType === 'first-input') {
          //     console.log('FID:', entry.processingStart - entry.startTime, 'ms')
          //   }
          //   if (entry.entryType === 'first-contentful-paint') {
          //     console.log('首次内容绘制(FCP):', entry.startTime, 'ms')
          //   }
          //   if (entry.name.startsWith('api-')) {
          //     console.log(
          //       `[API调用] ${entry.name.replace(
          //         'api-',
          //         ''
          //       )}: ${entry.duration.toFixed(2)}ms`
          //     )
          //   }
          //   if (
          //     entry.name.startsWith('route-') &&
          //     entry.name.endsWith('navigation')
          //   ) {
          //     console.log(
          //       `路由 ${entry.name
          //         .replace('route-', '')
          //         .replace('-navigation', '')} 切换耗时:${entry.duration.toFixed(
          //         2
          //       )}ms`
          //     )
          //   }
          if (entry.entryType === 'measure') {
            // 处理组件渲染耗时
            if (entry.name.startsWith('component-')) {
              const componentName = entry.name.replace('component-', '')
              console.log(
                `[性能监控] ${componentName} 渲染耗时: ${entry.duration.toFixed(
                  2
                )}ms`
              )
            }
          }
        })
      })

      // 指定要观察的性能条目类型
      observer.observe({ entryTypes: supportedTypes })
    },
  },
  watch: {
    '$route.query': {
      handler(newVal, oldVal) {
        let param_val = getObjFromUrl(window.location.href)
        if (param_val.brand_name != undefined && param_val.brand_name != '') {
          this.$store.dispatch(
            'user/changeBrandName',
            param_val.brand_name.split(',').map((item) => {
              return decodeURIComponent(item)
            })
          )
        }
        if (
          param_val.passActivedTab != undefined &&
          param_val.passActivedTab != ''
        ) {
          this.$store.dispatch(
            'user/changeActivedTab',
            decodeURIComponent(param_val.passActivedTab)
          )
        }
        if (param_val.cat_id != undefined && param_val.cat_id != '') {
          this.$store.dispatch(
            'user/changeCatId',
            decodeURIComponent(param_val.cat_id)
          )
        }
        if (param_val.cat_name != undefined && param_val.cat_name != '') {
          this.$store.dispatch(
            'user/changeCatName',
            decodeURIComponent(param_val.cat_name)
          )
        }
        if (param_val.rule_id != undefined) {
          this.$store.dispatch(
            'user/changeRuleId',
            decodeURIComponent(param_val.rule_id)
          )
        }
        if (param_val.analyse_typ != undefined) {
          this.$store.dispatch(
            'user/changeAnalyseTyp',
            decodeURIComponent(param_val.analyse_typ)
          )
        }
        if (param_val.r_rule_id != undefined) {
          this.$store.dispatch(
            'user/changeRouterRuleId',
            decodeURIComponent(param_val.r_rule_id)
          )
        }
        if (param_val.r_analyse_typ != undefined) {
          this.$store.dispatch(
            'user/changeRouterAnalyseTyp',
            decodeURIComponent(param_val.r_analyse_typ)
          )
        }
        if (param_val.words != undefined) {
          this.$store.dispatch(
            'user/changeWords',
            decodeURIComponent(param_val.words)
          )
        }
        if (param_val.label_level != undefined) {
          this.$store.dispatch(
            'user/changeLabelLevel',
            decodeURIComponent(param_val.label_level)
          )
        }
        if (param_val.aspect_type != undefined) {
          this.$store.dispatch(
            'user/changeAspectType',
            decodeURIComponent(param_val.aspect_type)
          )
        }
        if (param_val.word != undefined) {
          this.$store.dispatch(
            'user/changeSelectedKeyWards',
            decodeURIComponent(param_val.word)
          )
        }
        if (param_val.plat != undefined && param_val.plat != '') {
          this.$store.dispatch(
            'user/changeplants',
            param_val.plat.split(',').map((item) => {
              return decodeURIComponent(item)
            })
          )
        }
        if (param_val.kol_id != undefined) {
          this.$store.dispatch(
            'user/changeKolId',
            decodeURIComponent(param_val.kol_id)
          )
        }
        if (param_val.kol_name != undefined) {
          this.$store.dispatch(
            'user/changeKolName',
            decodeURIComponent(param_val.kol_name)
          )
        }
        if (param_val.start != undefined) {
          this.$store.dispatch(
            'user/changeStartMonth',
            decodeURIComponent(param_val.start)
          )
        }
        if (param_val.end != undefined) {
          this.$store.dispatch(
            'user/changeEndMonth',
            decodeURIComponent(param_val.end)
          )
        }
        if (param_val.CloudWord != undefined) {
          this.$store.dispatch(
            'user/changeCloudWord',
            decodeURIComponent(param_val.CloudWord)
          )
        }
        if (param_val.postBrandId != undefined) {
          this.$store.dispatch(
            'user/changeBrandId2',
            decodeURIComponent(param_val.postBrandId)
          )
        }
        if (param_val.postBrandName != undefined) {
          this.$store.dispatch(
            'user/changePostBrandName',
            decodeURIComponent(param_val.postBrandName)
          )
        }
      },
      immediate: true,
    },
    '$store.state.user.loginInfo': {
      handler(newVal, oldVal) {
        this.chageFavicon()
      },
    },
  },
  created() {
    // window.addEventListener('beforeunload', (e) => {
    //   debugger
    // })
    // this.getDefaultNameData()
    // this.getDefaultBrandOptions()
    window.onerror = function (message, url, lineNumber, columnNumber, error) {
      console.error(
        'Error: ' + message + '\nURL: ' + url + '\nLine Number: ' + lineNumber
      )
      const parsedError = ErrorStackParser.parse(error)
      const baseObj = getBaseErrorObj()
      baseObj.error_msg = message
      baseObj.stackTrace = parsedError
      clientError(baseObj)
      return true // 阻止浏览器默认行为
    }
    this.chageFavicon()
    // this.setupPerformanceObserver()
  },
  mounted() {
    let self = this
    this.listenInterValId = setInterval(() => {
      listenPerformance(self)
    }, 10000)
  },
  beforeDestroy() {
    localStorage.removeItem('defaultStartMonth')
    localStorage.removeItem('defaultEndMonth')
    if (this.listenInterValId) {
      clearInterval(this.listenInterValId)
      this.listenInterValId = null
    }
  },
}
</script>

<style>
</style>
